import { render, staticRenderFns } from "./KioskArrivalStatus.vue?vue&type=template&id=0ef89990&scoped=true"
import script from "./KioskArrivalStatus.vue?vue&type=script&lang=js"
export * from "./KioskArrivalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef89990",
  null
  
)

export default component.exports